import { PageHero, SectionHead, Reveal, Card, btnPrimary, ArrowIcon, usePageMeta } from "@/components/primitives";
import { EcosystemNet } from "@/components/visuals/Network";
import { ECOSYSTEM_PARTICIPANTS } from "@/lib/data";
import { Link } from "react-router-dom";

export default function Ecosystem() {
  usePageMeta(
    "TimePe Ecosystem | Connecting India's Financial Infrastructure",
    "TimePe connects banks, NBFCs, FinTechs, PSPs, insurers, agents, retailers, merchants, citizens and institutions into one trusted financial fabric."
  );
  return (
    <>
      <PageHero
        eyebrow="Ecosystem"
        lines={["Connecting the", "Financial Ecosystem."]}
        lead="No single institution builds trust alone. TimePe is designed as connective tissue between every participant in Bharat's financial ecosystem."
      />

      <section className="border-b border-line py-24 sm:py-32" data-testid="ecosystem-network">
        <div className="mx-auto max-w-[1440px] px-6 lg:px-8">
          <div className="grid items-center gap-12 lg:grid-cols-2">
            <Reveal>
              <EcosystemNet />
            </Reveal>
            <div>
              <SectionHead eyebrow="Participants" title="One Fabric, Ten Communities" />
              <div className="mt-10 grid grid-cols-2 gap-4">
                {ECOSYSTEM_PARTICIPANTS.map((p, i) => (
                  <Reveal key={p} delay={i * 0.04}>
                    <Card testid={`ecosystem-participant-${i}`} className="p-5">
                      <p className="font-display text-sm font-semibold text-mist">{p}</p>
                    </Card>
                  </Reveal>
                ))}
              </div>
            </div>
          </div>
          <Reveal delay={0.15} className="mt-16 flex flex-wrap gap-4">
            <Link to="/partners" data-testid="ecosystem-cta-partner" className={btnPrimary}>
              Build With Us <ArrowIcon />
            </Link>
          </Reveal>
        </div>
      </section>
    </>
  );
}
